import {ENDPOINT_VERSIONS} from './_endpoint-versions';

export const GET_ACTIVITY_LOGS_ENDPOINT = `/${ENDPOINT_VERSIONS.V2}/activity-logs`;
